import { IconFont } from '@lighthouse/bui'
import styled from 'styled-components'

export const Container = styled.div`
    padding-top: 6px;
`

export const FieldItemTitle = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    font-weight: 400;
    margin-left: 4px;
    line-height: 20px;
    word-wrap: break-word;
    white-space: pre-wrap;
`

export const Text = styled.span<{ color?: string }>`
    color: ${props => props.color || 'var(--color-gray-600)'};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    word-wrap: break-word;
    white-space: pre-wrap;
`
